/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export function UncollapseIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 4.59961C21 3.82641 20.3728 3.19922 19.5996 3.19922H5.59961C4.82641 3.19922 4.19922 3.82641 4.19922 4.59961V18.5996C4.19922 19.3728 4.82641 20 5.59961 20H19.5996C20.3728 20 21 19.3728 21 18.5996V4.59961ZM12 15.5996V12.1992H8.59961C8.26824 12.1992 8 11.931 8 11.5996C8 11.2682 8.26824 11 8.59961 11H12V7.59961C12 7.26824 12.2682 7 12.5996 7C12.931 7 13.1992 7.26824 13.1992 7.59961V11H16.5996C16.931 11 17.1992 11.2682 17.1992 11.5996C17.1992 11.931 16.931 12.1992 16.5996 12.1992H13.1992V15.5996C13.1992 15.931 12.931 16.1992 12.5996 16.1992C12.2682 16.1992 12 15.931 12 15.5996ZM22.1992 18.5996C22.1992 20.0356 21.0356 21.1992 19.5996 21.1992H5.59961C4.16367 21.1992 3 20.0356 3 18.5996V4.59961C3 3.16367 4.16367 2 5.59961 2H19.5996C21.0356 2 22.1992 3.16367 22.1992 4.59961V18.5996Z"
        fill="#3A5C84"
      />
    </svg>
  );
}
